module.exports = __webpack_public_path__ + "static/media/screenshot-7.bc1eb438.png";